module.exports = __webpack_public_path__ + "img/扬沙.e0554cf5.png";